EmailConfirmationEditCtrl = ($scope, $routeParams, $location, EmailConfirmationService, AccountService) ->
  $scope.params =
    token: $routeParams.token

  $scope.isLoading = true

  EmailConfirmationService.confirm($scope.params.token)
    .then (resp) ->
      AccountService.setConfirmationStatus() #turn true confirm status to prevent show warning message
      $scope.confirmed = true
    .catch (error) ->
      $scope.confirmed = false
    .finally ->
      $scope.isLoading = false

  $scope.backToDashboard = ->
    $location.path('/')

EmailConfirmationEditCtrl.$inject = [
  '$scope'
  '$routeParams'
  '$location'
  'EmailConfirmationService'
  'AccountService'
]

module.exports = EmailConfirmationEditCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/email-confirmation/edit-controller.coffee